import {Dialog, Flex, Button, Title, Text} from '@priority-software/priority-style-react';
import React from 'react';
import {showOfflineErrorMessage} from '../../_shared/Messages/actions/MessageActions';
import {texts} from './Texts';
import {Root} from 'react-dom/client';

export const offlineModalRef: React.RefObject<OfflineAlert> = React.createRef();

export async function renderOfflineAlert(root: Root) {
    root.render(<OfflineAlert ref={offlineModalRef} />);
    return offlineModalRef;
}
export class OfflineAlert extends React.Component<any, any> {
    text = (window as any).isRtl && (window as any).isRtl() ? texts.h : texts.e;

    constructor(props) {
        super(props);

        this.state = {
            isOnline: navigator.onLine
        };

        // window.addEventListener('online', this.setOnline);
        // window.addEventListener('offline', this.setOffline);
    }

    close = async () => {
        const props = {
            id: 'offline-modal',
            closable: false,
            title: `${this.text.stillNoConnection} 
            ${this.text.checkAgain}`,
            confirmButtonText: this.text.confirm,
            onConfirm: () => {},
            onClose: () => {}
        };

        if (!navigator.onLine) {
            showOfflineErrorMessage(props);
        } else {
            this.setOnline();
        }
    };

    setOnline = async () => {
        const oidc_mgr = (window as any).oidc_mgr;
        XMLHttpRequest.prototype.send = window['cacheSend'];
        const oidc_access_token = (window as any).oidc_access_token;

        if (!oidc_access_token) {
            this.setState({isOnline: true});
        } else {
            try {
                await oidc_mgr?.signinSilent();
            } catch (err) {
                await oidc_mgr?.signinSilent();
                this.setState({isOnline: true});
            } finally {
                this.setState({isOnline: true});
            }
        }
    };

    setOffline = async () => {
        XMLHttpRequest.prototype.send = () => false;
        this.setState({isOnline: false});
    };

    renderTitle = () => {
        return <Title skin="h2">{this.text.noConnectionTitle}</Title>;
    };

    renderContent = () => {
        return <Text>{this.text.noConnectionContent}</Text>;
    };

    renderFooter = () => {
        return (
            <Flex justifyContent="flex-start">
                <Button autoFocus={true} onClick={this.close}>
                    {this.text.mainButton}
                </Button>
            </Flex>
        );
    };

    render() {
        return (
            <Dialog
                closable={false}
                title={this.renderTitle()}
                isOpen={!this.state.isOnline}
                content={this.renderContent()}
                onClose={this.close}
                footer={this.renderFooter()}
                mask={true}
                size="large"
            />
        );
    }
}
